/**
*功能名称：数据源管理
*创 建 人：whr
*日    期：2023/06/15 10:15:17
*/
import { Methods } from '@newview/infrastructure';
import { DbCenterBaseApi } from "../DbCenterBaseApi";
import {DbCenterBaseApiV2} from "../DbCenterBaseApiV2";
export class CompontentDatasourceconfigApi extends DbCenterBaseApiV2 {
    public get ControllerName(): any {
        return 'compontent-datasourceconfig';
    }


 
}
